import svgData from "./svgData";
import { PathElement } from "../../svgHelpers";
import type { SVGProps, SVGElementProps } from "../../types";

const ClipboardOutline: SVGProps = (props: SVGElementProps) => (
  <>
    <PathElement {...props} path={svgData.path.d1} />
    <PathElement {...props} path={svgData.path.d2} />
    <PathElement {...props} path={svgData.path.d3} />
    <PathElement {...props} path={svgData.path.d4} />
  </>
);

export default ClipboardOutline;
